import { Component, computed, DestroyRef, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ScrollTopModule } from 'primeng/scrolltop';
import { FlagLanguagePipe, InfoLanguagePipe } from '@ls-commons/utils/pipes';
import { debounceTime, fromEvent, map, startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    ScrollTopModule,
    ButtonModule,
    RouterLink,
    FlagLanguagePipe,
    InfoLanguagePipe,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  hiddenTitle = true;
  hiddenLogo = true;

  private _isMobile = signal<boolean>(true);
  public isMobile = computed(() => this._isMobile());
  private _isTablet = signal<boolean>(true);
  public isTablet = computed(() => this._isTablet());

  destroyRef = inject(DestroyRef);

  constructor() {
    fromEvent(window, 'resize')
      .pipe(
        map((resize: Event) => (resize.target as Window).innerWidth),
        startWith(window.innerWidth),
        debounceTime(200),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(width => {
        this._isMobile.set(width <= 1024);
        this._isTablet.set(width <= 1024 && width > 640);
      });
  }
}
